/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { AbstractControl, FormControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

/**
 * @param control Control that has the validatior defined
 * @param form Complete form
 * @returns true if validation passed.
 * An object with the validation id and a message property inside if failed.
 * @example: { "date": { message: "Something went wrong"}}
 */
export function timeRangeValidator(
  control: AbstractControl,
  form: FormlyFieldConfig, options: any = {}
) {
  const model = control.value;

  if (!model) {
    return null;
  }
  const namespace = options.namespace;
  let from1;
  let to1;
  let days1;
  let from2;
  let to2;
  let days2;
  let from3;
  let to3;
  let days3;

  if(options.suffixFrom1){
   from1 = model[ namespace + options.suffixFrom1 ];
   to1 = model[ namespace + options.suffixTo1 ];
   days1 = model[ namespace + options.suffixDays1 ];
  }

  if(options.suffixFrom2){
    from2 = model[ namespace + options.suffixFrom2 ];
    to2 = model[ namespace + options.suffixTo2 ];
    days2 = model[ namespace + options.suffixDays2 ];
   }

   if(options.suffixFrom3){
    from3 = model[ namespace + options.suffixFrom3 ];
    to3 = model[ namespace + options.suffixTo3 ];
    days3 = model[ namespace + options.suffixDays3 ];
   }

  let errorFlag1 = true;
  let errorFlag2 = true;
  let errorPath = '';
  let message = '';

  if (from1 && from2 && to1 && to2 && from1 === from2 && to1 === to2 && days1 && days1 === days2) {
    message = "Values cannot be duplicate"; // between rows" + 1 + " and " + 2;
    errorFlag2 = false;
    errorPath = namespace + options.suffixFrom2;
  }
  if (from3 && to3 && to2 && from2 && from3 === from2 && to3 === to2 && days3 && days3 === days2) {
    message = "Values cannot be duplicate"; //between rows" + 2 + " and " + 3;
    errorFlag1 = false;
    errorPath = namespace + options.suffixFrom3;
  }
  if (from1 && from3 && to1 && to3 && from1 === from3 && to1 === to3 && days1 && days1 === days3) {
    message = "Values cannot be duplicate"; // between rows" + 1 + " and " + 3;
    errorFlag1 = false;
    errorPath = namespace + options.suffixFrom3;
  }

  let businessHour2 = namespace + options.suffixFrom2;
  let businessHour3 = namespace + options.suffixFrom3;

  if (errorFlag1 || errorFlag2) {
    //message = '';
    if (!control[ 'controls' ][`${businessHour2}`]?.errors?.required && control[ 'controls' ][`${businessHour2}`]?.status === 'INVALID') {
      control[ 'controls' ][`${businessHour2}`].status = 'VALID';
    }
    if (!control[ 'controls' ][`${businessHour3}`]?.errors?.required && control[ 'controls' ][`${businessHour3}`]?.status === 'INVALID') {
      control[ 'controls' ][`${businessHour3}`].status = 'VALID';
    }
  }

  return errorFlag1 && errorFlag2 ? null : {
    timeRange: {
      message,
      errorPath
    }
  };
}

